let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1lU5U")).then(() => parcelRequire('e4ND1'));